import { Image } from "../Image";
import { Menu, MenuItem } from "../Menu";

export class MockMenuItem implements MenuItem {
  uuid: string;
  title?: string | undefined;
  imgBackground: Image[];
  imgIcon: Image[];
  isPaginated = false;
  private static INDEX = 0;
  constructor() {
    MockMenuItem.INDEX++;
    this.uuid = `${MockMenuItem.INDEX}`;
    this.imgBackground = [];
    this.imgIcon = [];
    this.title = "title";
  }
}
export class MockMenu implements Menu {
  pages: MenuItem[] = [];
}
